module.exports = __webpack_public_path__ + "img/residence-permit-dont.980d6549.png";